import { Action } from "redux";
import { CreateEntityResult } from "../../Middleware/InlineEditMiddleware";
import { EntityNames } from "../reducers";

export enum EntitiesActionTypes {
    UPDATE_ENTITIES = "UPDATE_ENTITIES",
    RECONSTRUCT_ENTITIES = "RECONSTRUCT_ENTITIES",
    DELETE_ENTITIES = "DELETE_ENTITIES",
    CREATE_ENTITY_SUCCESS = "CREATE_ENTITY_SUCCESS",
    CLEAN_ENTITIES = "CLEAN_ENTITIES",
}

export type EntitiesActions =
    | ReconstructEntitiesAction
    | UpdateEntitiesAction
    | DeleteEntities
    | CreateEntitySuccess
    | Action<EntitiesActionTypes.CLEAN_ENTITIES>;

export interface UpdateEntitiesAction {
    type: EntitiesActionTypes.UPDATE_ENTITIES;
    entities: any;
    entityKey?: string;
}

/**
 * This action completely replaces specified entities in store.
 * UpdateEntitiesAction just merges existing entities with entities in action's payload.
 */
export interface ReconstructEntitiesAction {
    type: EntitiesActionTypes.RECONSTRUCT_ENTITIES;
    entities: any;
    entityKey?: string;
}

export interface DeleteEntities {
    type: EntitiesActionTypes.DELETE_ENTITIES;
    entityIds: (number | string)[];
    entityName: string;
}

export const deleteEntity: F2<number | string, string, DeleteEntities> = (entityId, entityName) => ({
    type: EntitiesActionTypes.DELETE_ENTITIES,
    entityIds: [entityId],
    entityName,
});

export const deleteEntities: F2<number[], string, DeleteEntities> = (entityIds, entityName) => ({
    type: EntitiesActionTypes.DELETE_ENTITIES,
    entityIds,
    entityName,
});

export interface CreateEntitySuccess<T = any> {
    type: EntitiesActionTypes.CREATE_ENTITY_SUCCESS;
    entityName: EntityNames;
    oldEntityId: number;
    entity: CreateEntityResult<T>;
}

type SubstituteEntity = <T>(
    oldId: number,
    entity: CreateEntityResult<T>,
    entityName: EntityNames
) => CreateEntitySuccess<T>;
export const substituteEntity: SubstituteEntity = (oldEntityId, entity, entityName) => ({
    type: EntitiesActionTypes.CREATE_ENTITY_SUCCESS,
    entityName,
    oldEntityId,
    entity,
});

export type CleanEntities = Action<EntitiesActionTypes.CLEAN_ENTITIES>;
export const cleanEntities = (): CleanEntities => ({
    type: EntitiesActionTypes.CLEAN_ENTITIES,
});
